import React, { useState } from "react";
import { ArrowRight, ArrowLeft, Mail, Lock } from "lucide-react";
import { toast } from "sonner";
import Logo from "../components/Logo";
import { useAuth } from "../lib/auth";

export default function Login({ onNavigate }) {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);
      onNavigate("dashboard");
    } catch (err) {
      toast.error("Sign in failed", { description: err.message });
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-ink px-5">
      <div className="pointer-events-none absolute -top-32 left-1/2 h-[500px] w-[700px] -translate-x-1/2 rounded-full bg-brand/15 blur-[150px]" />
      <div className="pointer-events-none absolute inset-0 grid-lines opacity-30" />

      <div className="relative w-full max-w-md">
        <button onClick={() => onNavigate("landing")} className="mb-8 inline-flex items-center gap-2 text-sm text-mist-muted transition-colors hover:text-mist">
          <ArrowLeft size={15} /> Back
        </button>

        <div className="glass rounded-[2rem] p-8">
          <Logo size={30} />
          <h1 className="mt-7 text-3xl font-semibold text-mist">Welcome back</h1>
          <p className="mt-2 text-sm text-mist-muted">Sign in to continue your journey.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <label className="mb-1.5 block text-xs font-medium text-mist-muted">Email</label>
              <div className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3 focus-within:border-brand">
                <Mail size={16} className="text-mist-muted" />
                <input
                  type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@email.com"
                  data-testid="login-email"
                  className="w-full bg-transparent text-sm text-mist outline-none placeholder:text-mist-muted/60"
                />
              </div>
            </div>
            <div>
              <label className="mb-1.5 block text-xs font-medium text-mist-muted">Password</label>
              <div className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3 focus-within:border-brand">
                <Lock size={16} className="text-mist-muted" />
                <input
                  type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  data-testid="login-password"
                  className="w-full bg-transparent text-sm text-mist outline-none placeholder:text-mist-muted/60"
                />
              </div>
            </div>
            <button type="submit" data-testid="login-submit" className="btn-primary flex w-full items-center justify-center gap-2">
              Sign in <ArrowRight size={16} />
            </button>
          </form>

          <button onClick={() => onNavigate("forgot")} data-testid="forgot-password-link" className="mt-4 block w-full text-center text-sm text-mist-muted transition-colors hover:text-mist">
            Forgot your password?
          </button>

          <p className="mt-6 text-center text-sm text-mist-muted">
            New here?{" "}
            <button onClick={() => onNavigate("signup")} className="font-medium text-brand hover:underline">
              Create your free account
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}
